import { render, staticRenderFns } from "./previewexam.vue?vue&type=template&id=afc25ddc&scoped=true&"
import script from "./previewexam.vue?vue&type=script&lang=js&"
export * from "./previewexam.vue?vue&type=script&lang=js&"
import style0 from "./previewexam.vue?vue&type=style&index=0&id=afc25ddc&prod&scoped=true&lang=scss&"
import style1 from "./previewexam.vue?vue&type=style&index=1&id=afc25ddc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc25ddc",
  null
  
)

export default component.exports